<template>
<div>
  <div class="merge-tool-bar" v-show="$store.state.isShowMergePicMode">
    <button class="cancel" v-on:click="$store.state.isShowMergePicMode = false">{{ $t('imagewall.cancel') }}</button>
    <button class="merge"  v-on:click="merge" data-toggle="modal" data-target=".bs-merge-modal">{{ $t('imagewall.merge') }} ({{ selected.length }})</button>
  </div>
  <!-- 拼图合成 -->
  <div class="modal fade bs-merge-modal" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" ref="mergedBox">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h1>{{ $t('imagewall.longPressSaveTips') }}</h1>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="mergedPicSrc=''"><span aria-hidden="true">&times;</span></button>
        </div>
        <div class="modal-body merged-pic-image-area">
          <p v-if="!mergedPicSrc">合成拼图中，请稍等...</P>
          <img class="img-fluid mx-auto" :src="mergedPicSrc">
        </div>
      </div>
    </div>
  </div>
</div>
 
</template>

<script>
import Vue from 'vue'
export default {
  data: () => ({
    mergedPicSrc: '',
  }),
  props: {
    selected: Array,
    title: String
  },
  methods: {
    merge() {
      Vue.axios.post('/api/merge', {
        photos: this.selected,
        title: this.title
      }
      ).then(({ status, data }) => {
        if (status === 200) {
          //console.log(data.result)
          if (data && data.result) {
            const { url } = data.result
            this.mergedPicSrc = url
            this.$store.state.isShowMergePicMode = false
          }
        }
      })
    },
  }
}
</script>
